import styled from "styled-components";

const Header = styled.header`
position: relative;
`
const HeaderFon = styled.div`
position: relative;
width: 100%;
height: 100vh;
`;

const HeaderFonImg = styled.img`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
object-fit: cover;
`;

const HeaderTitleBlock = styled.div`
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, 0%);
`;
const HeaderTitle = styled.h1`
font-size: 2.75rem;
letter-spacing: 5px;
font-weight: 300;
text-align: center;
font-family: 'Bebas Neue';
text-transform: uppercase;
color: rgba(255, 255, 255, 1);
transition: color 0.5s ease 0s;
`;

const HeaderCubtitle = styled.p`
text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 0.875rem;
`;

const HeaderScroll = styled.div`
position: absolute;
bottom: 9%;
left: 50%;
transform: translate(-50%, 0%);
text-transform: uppercase;
color: rgba(255, 255, 255, 1);
letter-spacing: 0.3rem;
font-size: 0.6rem;
`;

const LogoPosition = styled.div`
position: absolute;
top: 4%;
left: 50%;
transform: translate(-50%, 0%);
`

export { HeaderCubtitle, HeaderScroll, HeaderTitle, HeaderFon, HeaderFonImg, HeaderTitleBlock, LogoPosition, Header };